import { render, staticRenderFns } from "./formRequests.vue?vue&type=template&id=1700fca8&scoped=true&"
import script from "./formRequests.vue?vue&type=script&lang=js&"
export * from "./formRequests.vue?vue&type=script&lang=js&"
import style1 from "./formRequests.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700fca8",
  null
  
)

export default component.exports